/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2026 Rochester Software Associates (service@rocsoft.com)
 */

import api from './api';

export const getTags = async () => {
    return api.get('');
};

export const createTag = async (name) => {
    return api.put('', { name });
};

export const deleteTag = async (tagID) => {
    return api.delete(tagID);
};

export const renameTag = async (tagID, newName) => {
    return api.patch(`${tagID}/rename`, { newName });
};

export const changePositionTag = async (tagID, newPosition) => {
    return api.patch(`${tagID}/changePosition`, { newPosition });
};

